import { render, staticRenderFns } from "./iconOrder.vue?vue&type=template&id=30dae064"
import script from "./iconOrder.vue?vue&type=script&lang=js"
export * from "./iconOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports